function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.507 2.063)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M395.182,298.913a3.34,3.34,0,1,1,3.341-3.34A3.344,3.344,0,0,1,395.182,298.913Zm0-4.9a1.559,1.559,0,1,0,1.56,1.56A1.562,1.562,0,0,0,395.182,294.013Z",
  transform: "translate(-391.843 -292.233)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.262)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M403.394,290.379a.974.974,0,0,0-.617-.209h0a.975.975,0,0,0-.618.209.623.623,0,0,0,0,1.007,5.186,5.186,0,0,1,0,8.374.624.624,0,0,0,0,1.006.975.975,0,0,0,.618.209h0a.974.974,0,0,0,.617-.209h0A6.435,6.435,0,0,0,403.394,290.379Z",
  transform: "translate(-399.598 -290.17)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M401.09,292.255a1.022,1.022,0,0,0-1.236,0,.623.623,0,0,0,0,1.007,2.862,2.862,0,0,1,0,4.621.625.625,0,0,0,0,1.007,1.022,1.022,0,0,0,1.236,0A4.11,4.11,0,0,0,401.09,292.255Z",
  transform: "translate(-399.598 -290.17)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M386.971,300.766a.979.979,0,0,0,.618.209h0a.975.975,0,0,0,.618-.209.623.623,0,0,0,0-1.007,5.186,5.186,0,0,1,0-8.374.624.624,0,0,0,0-1.006.975.975,0,0,0-.618-.209h0a.979.979,0,0,0-.618.209h0A6.435,6.435,0,0,0,386.971,300.766Z",
  transform: "translate(-384.336 -290.17)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M389.275,298.89a1.02,1.02,0,0,0,1.236,0,.623.623,0,0,0,0-1.007,2.862,2.862,0,0,1,0-4.621.623.623,0,0,0,0-1.007,1.022,1.022,0,0,0-1.236,0A4.111,4.111,0,0,0,389.275,298.89Z",
  transform: "translate(-384.336 -290.17)"
});

function SvgActiveOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#39d94c",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.694,
    height: 10.805,
    viewBox: "0 0 21.694 10.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveOn);
export default __webpack_public_path__ + "static/media/active_on.0becf87609e7461b6f43ec6e80fa12aa.svg";
export { ForwardRef as ReactComponent };